module.exports = __webpack_public_path__ + "img/42.bbc1a6e6.jpg";